import { DEFAULT_CURRENCY, moneyFormat } from "@redotech/money/util";
import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  priceConditionFromModel,
  validatePriceCondition,
  type NonReturnedValueState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const NON_RETURNED_VALUE = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<NonReturnedValueState>
  >,
): ConditionType<NonReturnedValueState, Condition.NonReturnedValue> => ({
  name: "Non-returned value",
  description(state) {
    if (!state.priceOption) {
      return "The total return value of all items in the order that the customer is not returning";
    }
    return `The total return value of all items not returned is ${state.priceOption.toLowerCase()} ${moneyFormat({ amount: +state.amount, currency: DEFAULT_CURRENCY })}`;
  },
  Details(props: ConditionTypeDetailsProps<NonReturnedValueState>) {
    return React.createElement(Details, props);
  },
  empty: { amount: (0).toFixed(2), priceOption: null },
  fromModel(model) {
    return priceConditionFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.NON_RETURNED_VALUE,
      amount: +state.amount,
      priceOption: state.priceOption,
    };
  },
  valid(state) {
    return validatePriceCondition(state).valid;
  },
});

export { type NonReturnedValueState } from "@redotech/redo-model/return-flow/condition-validate";
